import { InlineEdit, FauxInlineEdit } from './InlineEdit';
import type { PageHeaderInlineEditProps, FauxPageHeaderInlineEditProps } from './types';

export const PageHeaderInlineEdit = (props: PageHeaderInlineEditProps) => {
  return <InlineEdit variant="pageHeader" {...props} />;
};

export const FauxPageHeaderInlineEdit = (props: FauxPageHeaderInlineEditProps) => {
  return <FauxInlineEdit variant="pageHeader" {...props} />;
};
